"use client";

import { useRef } from "react";
import { ArrowUpRight } from "lucide-react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
gsap.registerPlugin(useGSAP, ScrollTrigger);
const rows = [{
  number: "01",
  eyebrow: "HIGIENE",
  headline: "Sistemas de lavagem otimizados.",
  body: "Garantimos a máxima eficácia na higienização de tanques e superfícies industriais. Os nossos sistemas reduzem o consumo de água e químicos, assegurando conformidade total com as normas de segurança alimentar.",
  certs: ["ISO 22000", "FDA"],
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/lavagem_tanques.png",
  alt: "Sistema de lavagem de tanques em aço inoxidável em ambiente industrial",
  imageLeft: true
}, {
  number: "02",
  eyebrow: "PRECISÃO",
  headline: "Pulverização de alta performance.",
  body: "Tecnologia de ponta para aplicação precisa de revestimentos, lubrificantes e agentes de conservação. Otimize o seu processo produtivo com controlo absoluto sobre o volume e a distribuição do spray.",
  certs: ["CE", "ATEX"],
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/pulverizacao_precisao.png",
  alt: "Bicos de pulverização industrial em operação de alta precisão",
  imageLeft: false
}, {
  number: "03",
  eyebrow: "EFICIÊNCIA",
  headline: "Automação de processos críticos.",
  body: "Soluções integradas para linhas de produção automatizadas. Aumente a produtividade e reduza o desperdício com sistemas de controlo inteligente adaptados às necessidades específicas da sua indústria.",
  certs: ["CE", "IEC"],
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/automacao_industrial.png",
  alt: "Linha de produção automatizada com sistemas de pulverização integrados",
  imageLeft: true
}];
export default function Solutions() {
  const container = useRef<HTMLDivElement>(null);
  useGSAP(() => {
    const el = container.current;
    if (!el) return;
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.set(".intro-eyebrow", {
        y: 16
      });
      gsap.set(".intro-heading", {
        y: 24
      });
      gsap.to(".intro-eyebrow", {
        opacity: 1,
        y: 0,
        duration: 0.7,
        ease: "power3.out",
        scrollTrigger: {
          trigger: ".intro-block",
          start: "top 85%",
          once: true
        }
      });
      gsap.to(".intro-heading", {
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: "power3.out",
        delay: 0.1,
        scrollTrigger: {
          trigger: ".intro-block",
          start: "top 85%",
          once: true
        }
      });
      const rowEls = gsap.utils.toArray<HTMLElement>(".feature-row");
      rowEls.forEach(row => {
        const imageWrap = row.querySelector(".row-image-wrap");
        const textEls = row.querySelectorAll(".row-text > *");
        if (imageWrap) {
          gsap.set(imageWrap, {
            y: 40
          });
          gsap.to(imageWrap, {
            opacity: 1,
            y: 0,
            duration: 0.9,
            ease: "power3.out",
            scrollTrigger: {
              trigger: row,
              start: "top 80%",
              once: true
            }
          });
          const img = imageWrap.querySelector(".row-image");
          if (img) {
            gsap.to(img, {
              y: -20,
              ease: "none",
              scrollTrigger: {
                trigger: row,
                start: "top bottom",
                end: "bottom top",
                scrub: true
              }
            });
          }
        }
        if (textEls.length) {
          gsap.set(textEls, {
            y: 24
          });
          gsap.to(textEls, {
            opacity: 1,
            y: 0,
            duration: 0.7,
            ease: "power3.out",
            stagger: 0.08,
            scrollTrigger: {
              trigger: row,
              start: "top 80%",
              once: true
            }
          });
        }
      });
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set([".intro-eyebrow", ".intro-heading", ".row-image-wrap", ".row-text > *"], {
        opacity: 1,
        y: 0
      });
    });
    const refresh = () => ScrollTrigger.refresh();
    requestAnimationFrame(refresh);
    if (document.readyState === "complete") refresh();else window.addEventListener("load", refresh, {
      once: true
    });
    document.fonts?.ready.then(refresh);
  }, {
    scope: container
  });
  return <section data-section-id="31452" id="foodproductionsprayingsolutions" className="bg-background text-foreground py-32 md:py-44 overflow-hidden">
      <div ref={container} className="mx-auto max-w-[1440px] px-5 md:px-8 lg:px-12">
        <div className="intro-block mx-auto max-w-[720px] text-center">
          <div className="intro-eyebrow inline-flex items-center gap-2 rounded-lg border px-4 py-2 border-border">
            <span className="h-1.5 w-1.5 rounded-lg bg-primary" />
            <span className="text-xs font-medium uppercase tracking-wider text-muted-foreground">
              Soluções Eurocontrol
            </span>
          </div>
          <h2 className="intro-heading font-default mt-8 text-4xl md:text-6xl lg:text-7xl font-normal text-foreground" style={{
          opacity: 0,
          letterSpacing: "-0.03em",
          lineHeight: 1.02
        }}>Alimentar &amp; Bebidas</h2>
          <p className="mt-6 text-base md:text-lg font-light text-muted-foreground" style={{
          lineHeight: 1.55
        }}>OPTIMIZING SPRAY TECHNOLOGY FOR FOOD &amp; BEVERGE</p>
        </div>

        <div className="mt-24 md:mt-32 flex flex-col gap-24 md:gap-32">
          {rows.map((row, i) => <div key={row.number} data-index={i} className="feature-row grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-center">
              <div className={`row-image-wrap ${row.imageLeft ? "lg:col-span-7 lg:order-1" : "lg:col-span-7 lg:order-2"} order-1 relative`} style={{
            opacity: 0
          }}>
                <div className="relative">
                  <div className="relative overflow-hidden rounded-2xl border border-border bg-card">
                    <img src={row.image} alt={row.alt} loading="lazy" decoding="async" className="row-image w-full h-[360px] md:h-[460px] lg:h-[520px] object-cover" />
                  </div>
                </div>
              </div>

              <div className={`row-text ${row.imageLeft ? "lg:col-span-5 lg:order-2" : "lg:col-span-5 lg:order-1"} order-2`}>
                <div className="font-serif text-4xl md:text-5xl font-normal text-primary" style={{
              opacity: 0,
              letterSpacing: "-0.02em",
              lineHeight: 1
            }}>
                  {row.number}
                </div>
                <div className="mt-6 text-xs font-medium uppercase tracking-wider text-secondary" style={{
              opacity: 0
            }}>
                  {row.eyebrow}
                </div>
                <h3 className="font-default mt-4 text-2xl md:text-3xl lg:text-4xl font-medium text-foreground" style={{
              opacity: 0,
              letterSpacing: "-0.02em",
              lineHeight: 1.12
            }}>
                  {row.headline}
                </h3>
                <p className="mt-5 text-base md:text-lg font-light text-muted-foreground" style={{
              opacity: 0,
              lineHeight: 1.55
            }}>
                  {row.body}
                </p>
                <div className="mt-6 flex flex-wrap gap-2" style={{
              opacity: 0
            }}>
                  {row.certs.map((cert, j) => <Badge key={cert} data-index={j} variant="outline" className="rounded-lg px-3 py-1 text-[11px] font-medium uppercase tracking-wider border-border bg-accent text-accent-foreground">
                      {cert}
                    </Badge>)}
                </div>
              </div>
            </div>)}
        </div>

        <div className="mt-24 md:mt-32 flex justify-center">
          <Button asChild variant="ghost" className="group h-auto rounded-lg px-0 py-2 text-base font-normal hover:bg-transparent text-foreground">
            <Link to="/ProductsPage" className="inline-flex items-center gap-2">
              <span className="relative">
                Ver catálogo completo
                <span className="absolute left-0 -bottom-1 h-px w-0 transition-all duration-300 group-hover:w-full bg-primary" />
              </span>
              <ArrowUpRight className="size-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1 text-primary" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}